import { render, staticRenderFns } from "./welcomeBeforeSession.vue?vue&type=template&id=19c37c72&scoped=true"
import script from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
export * from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
import style0 from "./welcomeBeforeSession.vue?vue&type=style&index=0&id=19c37c72&prod&scoped=true&lang=css"
import style1 from "./welcomeBeforeSession.vue?vue&type=style&index=1&id=19c37c72&prod&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c37c72",
  null
  
)

export default component.exports